import React, { useEffect } from "react";
import { Button, Col, Row } from "reactstrap";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { UserStruct, UserTypes } from "api";
import { APIClient } from "api/apiCore";
import { Utils } from "helpers/utils";
// import { Utils } from "../../../helpers/utils";
const Welcome = () => {

  // for test
  // const test = useEffect(()=>{
  //   const ar1 = [{id:'1', text:'one'},{id:'2', text:'two'},{id:'3', text:'three'},];
  //   const ar2 = [{id:'3', text:'three'},{id:'4', text:'four'}];
  //   const uniqueMessages = new Map(
  //     [...ar1, ...ar2].map((message) => [message.id, message])
  //   );
  //   const uniqueMessages2 = new Map(
  //     [...ar1, ...ar2].map((message) => [message.id, message])
  //   );    
  //   console.log(uniqueMessages);
  //   console.log('tet');
  // },[]);

  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.Profile2,
    (layout: any) => layout.Layout,
    (state: UserStruct, layout) => ({
      profile: state,
      chatConnectError: layout.chatConnectError,
    })
  );
  const { profile, chatConnectError } = useAppSelector(storeData);
  const fnTest = async () => {
    const api = new APIClient();
    const resp = await api.fnPostForm("/test-post-arg", { name: "john", age: 55 });
    //console.log(resp);
  }
  // console.log(profile);
  //{console.log([chatConnectError, Utils.MSG_CHAT_DISCONNECT, chatConnectError == Utils.MSG_CHAT_DISCONNECT])};
  return (
    <React.Fragment>
      <div className="chat-welcome-section">
        <Row className="w-100 justify-content-center">
          <Col xxl={5} md={7}>
            <div className="p-4 text-center">
              <div className="avatar-xl mx-auto mb-4">
                <div className="avatar-title bg-soft-primary rounded-circle">
                  {/* <i className="bx bxs-message-alt-detail display-4 text-primary m-0"></i> */}
                  <img src="/icons/logo512.png" width={120}></img>
                </div>
              </div>

              <h4>ยินดีต้อนรับคุณ {profile.nickName} สู่ระบบ {process.env.REACT_APP_NAME}</h4>
              <p className="text-muted mb-4 ">
                {profile.userType == UserTypes.Employee ?
                  ("สิ่งสำคัญคือ การให้บริการลูกค้าที่ดี ข้อมูลถูกต้อง รวดเร็ว แม่นยำ") :
                  ("ท่านสามารถเริ่มต้นสร้างบทสนทนา เราจะมีเจ้าหน้าที่มาบริการท่าน อย่างเร็วที่สุด")}
              </p>

              {chatConnectError && (
                <div className="alert alert-danger fade show global-error text-center" role="alert">
                  {/* <span>{chatConnectError}</span> */}
                  <span dangerouslySetInnerHTML={{ __html: chatConnectError }} />
                  {/* <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button> */}
                  {/* {chatConnectError == Utils.MSG_CHAT_DISCONNECT && (<a href="#" onClick={(e) => { e.preventDefault(); window.location.reload(); }}> รีโหลด</a>)} */}
                </div>
              )}

              {/* <button onClick={fnTest}>test</button> */}

              {/* <Button type="button" className="btn btn-primary w-lg">
                Get Started
              </Button> */}
            </div>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Welcome;
